import { forwardRef } from 'react';
import { Flex } from 'rebass/styled-components';

import { rem } from '@blueprint/ui';

export const ReplyWrapper = forwardRef(({ children }, ref) => (
  <Flex
    as="li"
    sx={{
      gap: rem(8),
      overflowWrap: 'anywhere',
      marginBottom: rem(16),
    }}
    ref={ref}
  >
    {children}
  </Flex>
));
